<template>
  <div :class="navBarFixed== true ?'bzBg scrollHead barwrap':'bzBg scrollHead'">
    <div class="bzDiv update-bzDiv" v-if="update">
      <span class="fL">修改资质证明</span>
      <div class="bzCon-two fL" style="width:800px">
        &nbsp;
      </div>
      <div class="bzBtn-reject fL">
        <el-button class="fL marR20" style="width: 120px" @click="cancelForm()">取消</el-button>
        <el-button type="primary" class="fL" style="width: 120px;" @click="submitForm()">
          提交审核
        </el-button>
      </div>
    </div>
    <div class="bzDiv" v-else>
      <span class="fL">填写资质证明</span>
      <div class="bzCon-two fL" style="width: 680px">
        <div class="bzNum fL marR8 success" style="display:flex;align-items:center">
          <i class="el-icon-circle-check icon-circle-success marR8"/>
          填写基本信息
        </div>
        <div class="line fL marR8">----------</div>
        <div class="bzNum fL marR8 success">
          <div class=" fL icon-circle-open marR8">2</div>
          上传资质信息
        </div>
      </div>
      <div class="bzBtn-two fL">
        <el-button class="fL marR20" @click="previousForm()">上一步</el-button>
        <el-button class="fL marR20" @click="cancelForm()">取消</el-button>
        <el-button type="primary" class="fL" @click="submitForm()">
          提交审核
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  name: 'Navigation',
  props: {
    update: {
      type: Boolean,
      default: true
    },
    formName: {
      type: String,
      default: 'form'
    }
  },
  data: function () {
    return {
      navBarFixed: false
    }
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes('brand')
    }
  },
  watch: {},
  created: function () {},
  mounted: function () {
    window.addEventListener('scroll', this.ScrollHead)
  },
  methods: {
    ScrollHead: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.navBarFixed = scrollTop > 150
    },
    submitForm: function (formName) {
      this.$emit('submit_form', formName)
    },
    formEvent: function (form) {
      this.formValidate = form.valid
      this.formData = form.data
    },
    cancelForm: function () {
      let url = '/'
      let urlHash = {}
      if (this.$route.query['customer_id']) {
        urlHash['customer_id'] = this.$route.query['customer_id']
      }
      if (this.$route.query['clientId']) {
        urlHash['clientId'] = this.$route.query['clientId']
      }
      if (this.$route.query['loginParam']) {
        urlHash['loginParam'] = this.$route.query['loginParam']
      }
      url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
      this.$router.push(url)
    },
    previousForm: function () {
      if (!this.packageId) {
        this.packageId = this.$route.params.package_id || 0
      }
      let url = '/qulification/base/' + this.packageId
      let urlHash = {}
      if (this.$route.query['customer_id']) {
        urlHash['customer_id'] = this.$route.query['customer_id']
      }
      if (this.$route.query['clientId']) {
        urlHash['clientId'] = this.$route.query['clientId']
      }
      if (this.$route.query['loginParam']) {
        urlHash['loginParam'] = this.$route.query['loginParam']
      }
      url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
      this.$router.push(url)
    }
  }
}

</script>
<style>
.bzDiv {
  overflow: hidden;
  padding-bottom: 5px;
}

.bzCon-two {
  width: 797px;
  display: flex;
  align-items: center;
}

.bzBtn-two {
  width: 403px;
}

.bzBg {
  background: #f9f9f9;
  padding-bottom: 10px
}

.scrollHead {
  width: 100%;
  position: fixed;
  top: 0;
  z-index:100;
  height: 70px;
  background: rgba(255, 255, 255, 0.8);
  display: none;
  border-bottom: 1px solid #E1E6F1;
}

.barwrap {
  display: block;
}

.scrollHead .bzDiv {
  width: 1200px;
  margin: auto;
  position: absolute;
  top:5px;
  bottom: 0;
  height: 40px;
  left: 0;
  right: 0;
}

.scrollHead {
  padding-bottom: 0;
}

.bzDiv>span {
  padding-top: 12px;
  font-size: 14px;
  color: #2E334A;
  letter-spacing: 0;
  line-height: 16px;
  padding-right: 30px;
  font-weight: bold
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue